import React from 'react';
import { Table, Card } from 'react-bootstrap';

function Alimentacion() {

    const alimentos = [
        { N: '1', T: 'Sal', D: 'Exceso sodio causa retención de líquidos', C: '0' },
        { N: '2', T: 'Alimentos Grasos', D: 'Evita el Exceso de alimentos con grasas saturadas', C: '900' },
        { N: '3', T: 'Harina', D: 'No comas mucho pan y alimentos derivados', C: '364' },
        { N: '4', T: 'Dulces', D: 'Evita comer mucho dulce, es peor que la grasa', C: '278' },
        { N: '5', T: 'Arroz', D: 'Exceso carbohidratos te harán subir mucho de peso', C: '130' },
        { N: '6', T: 'Gaseosa', D: 'Exceso de azúcar, si puedes dejarlo totalmente mucho mejor', C: '41' },
        { N: '7', T: 'Jugos', D: 'Las frutas son muy saludables, pero si lo que quieres es bajar de peso no los consumas como jugo, es casi igual que consumir gaseosa', C: '54' },
        { N: '8', T: 'Alcohol', D: 'Exceso Alcohol además de causarte muchos problemas de salud, son calorías bacías que no nos aportan ningún beneficio si de bajar peso se trata', C: '295' }
    ];

    const Nutricionistas = [
        { N: 'Carlos Quintero', D: 'Nuestra comida debería ser nuestra medicina y nuestra medicina debería ser nuestra comida.-Hipócrates.', I: 'https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Maria Solano', D: 'Comer bien es una forma de respetarse a uno mismo.', I: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Pedro Almiran', D: 'Si pudiésemos dar a cada individuo la cantidad adecuada de nutrición y ejercicio, ni muy poco ni demasiado, habríamos encontrado el camino más seguro hacia la salud.-Hipócrates.', I: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Camila Nieves', D: 'Uno debe comer para vivir; no vivir para comer.-Sócrates.', I: 'https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Jose Guzman', D: 'Desayuna como un rey, almuerza como un príncipe y cena como un mendigo.-Adelle Davis.', I: 'https://images.pexels.com/photos/1076605/pexels-photo-1076605.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Josefina Montes', D: 'Cuando la dieta es incorrecta, la medicina no sirve para nada. Cuando la dieta es correcta, la medicina no es necesaria.', I: 'https://images.pexels.com/photos/372042/pexels-photo-372042.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' }
    ];

    return (
        <React.Fragment>
            <section className='tusalud-alimentacion'>
                <h1><span className='logo'>&nbsp;TU&nbsp;</span>SALUD <br /> <span className='subtitle'>Alimentación</span></h1>
            </section>

            <section className='resumen'>

                <div className='title-center'>
                    <h2>Pautas para una alimentación equilibrada</h2>
                    <p>Una alimentación equilibrada es aquella que cubre los requisitos nutricionales necesarios para
                        que nuestro organismo pueda desempeñar de forma efectiva todas sus funciones. Es decir,
                        consiste en aportar a nuestro organismo una gran variedad de alimentos que, en conjunto,
                        consigan aportar todos los nutrientes esenciales para desarrollar todas nuestras actividades y mantenernos saludables.
                        <br />
                        <br />
                        A la hora del consumo, es importante que la variedad de alimentos dentro de cada grupo sea lo mayor posible,
                        ya que cada alimento es único y nos aporta determinados nutrientes, logrando así, un aporte más completo.
                        <br />
                        <br />
                        Paula Penedo - veritasint, Pautas para una alimentación equilibrada en cada etapa de la vida
                        <br /> https://www.veritasint.com/blog/es/pautas-alimentacion-equilibrada/
                    </p>

                    <br />

                    <p>Te mostraremos una lista de alimentos que te recomendamos moderar su consumo para bajar de peso y mejorar tu salud:</p>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                                <th>Num</th>
                                <th>Alimento</th>
                                <th>Descripción</th>
                                <th>Calorías x 100gr</th>
                            </tr>
                        </thead>
                        <tbody>
                            {alimentos.map(pro => (
                                <tr key={pro.N}>
                                    <td>{pro.N}</td>
                                    <td>{pro.T}</td>
                                    <td>{pro.D}</td>
                                    <td>{pro.C}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <h2>Nuestros nutricionistas están listos para darte una guía alimenticia especializada para ti.</h2>

                    <div className='especialistas'>
                        {Nutricionistas.map(proN => (
                            <Card key={proN.N} style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={proN.I} />
                                <Card.Body>
                                    <Card.Title>{proN.N}</Card.Title>
                                    <Card.Text>
                                        {proN.D}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>

        </React.Fragment>
    );
}
export default Alimentacion;